import { extendTheme } from "@chakra-ui/react";
import '@fontsource/lato';
import '@fontsource/open-sans';
import '@fontsource/poppins'; // Import the entire font


const theme = extendTheme({
  fonts: {
    body: "'Open Sans', sans-serif",
    heading: "'Poppins', 'Lato', 'Raleway', sans-serif",
  },
});

export default theme;